import { useState } from 'react';
import Navigation from './components/Navigation';
import ModuleCard from './components/ModuleCard';

const modules = [
  {
    id: 'magic-drawing',
    icon: 'ri-brush-line',
    title: '神奇画板',
    description: '用AI创作属于你的艺术作品',
    color: 'pink',
    features: ['AI辅助绘画', '创意涂鸦', '作品分享'],
    grade: '1-2年级'
  },
  {
    id: 'smart-companion',
    icon: 'ri-robot-line',
    title: '智能对话小伴侣',
    description: '和AI聊天，学习新知识',
    color: 'blue',
    features: ['语音对话', '趣味问答', '知识学习'],
    grade: '3年级'
  },
  {
    id: 'image-recognition',
    icon: 'ri-camera-line',
    title: '图像识别小能手',
    description: '让AI帮你认识世界万物',
    color: 'green',
    features: ['物体识别', '动植物百科', '拍照识别'],
    grade: '4年级'
  },
  {
    id: 'voice-assistant',
    icon: 'ri-mic-line',
    title: '语音助手',
    description: '用声音控制AI完成任务',
    color: 'purple',
    features: ['语音指令', '智能提醒', '故事朗读'],
    grade: '3-4年级'
  },
  {
    id: 'story-creator',
    icon: 'ri-book-2-line',
    title: 'AI故事创作平台',
    description: '用AI创作属于你的绘本故事',
    color: 'rose',
    features: ['故事生成', '图片生成', '视频生成'],
    grade: '1-6年级'
  },
  {
    id: 'algorithm-games',
    icon: 'ri-gamepad-line',
    title: '算法小游戏',
    description: '在游戏中理解AI的工作原理',
    color: 'orange',
    features: ['趣味编程', '逻辑训练', '闯关挑战'],
    grade: '5-6年级'
  },
  {
    id: 'creative-workshop',
    icon: 'ri-palette-line',
    title: '创意工坊',
    description: '用AI实现你的奇思妙想',
    color: 'indigo',
    features: ['创意设计', '故事创作', '音乐生成'],
    grade: '5-6年级'
  },
  {
    id: 'computational-thinking',
    icon: 'ri-brain-line',
    title: '计算思维训练营',
    description: '理解数据、计算和算法思想',
    color: 'teal',
    features: ['数据表达', '计算思维', '算法思想'],
    grade: '3-6年级'
  },
  {
    id: 'ai-recognition',
    icon: 'ri-eye-line',
    title: 'AI识别体验馆',
    description: '体验数字、车牌等AI识别',
    color: 'cyan',
    features: ['手写识别', '车牌识别', '物体识别'],
    grade: '4-6年级'
  }
];

const gradeModules = [
  {
    id: 'grade1',
    grade: '一年级',
    title: '初识AI小伙伴',
    description: '体验身边的人工智能应用',
    icon: 'ri-star-smile-line',
    color: 'from-pink-400 to-pink-600',
    buttonColor: 'from-pink-500 to-pink-600',
    objectives: ['认识家庭中的AI', '体验智能设备', '学习使用规范']
  },
  {
    id: 'grade2',
    grade: '二年级',
    title: '探索AI世界',
    description: '自主体验生活中的AI应用',
    icon: 'ri-earth-line',
    color: 'from-green-400 to-emerald-600',
    buttonColor: 'from-green-500 to-emerald-600',
    objectives: ['发现社会中的AI', '畅想AI应用', '保护个人隐私']
  },
  {
    id: 'grade3',
    grade: '三年级',
    title: 'AI学习工具',
    description: '体验在线学习中的智能工具',
    icon: 'ri-tools-line',
    color: 'from-purple-400 to-purple-600',
    buttonColor: 'from-purple-500 to-purple-600',
    objectives: ['了解AI技术', '解决学习问题', '养成良好习惯']
  },
  {
    id: 'grade4',
    grade: '四年级',
    title: 'AI识别与数据',
    description: '体验AI识别应用，理解数据作用',
    icon: 'ri-eye-line',
    color: 'from-blue-400 to-blue-600',
    buttonColor: 'from-blue-500 to-blue-600',
    objectives: ['手写数字识别', '理解数据编码', '生成式AI辅助']
  },
  {
    id: 'grade5',
    grade: '五年级',
    title: '算法与智能系统',
    description: '理解算法概念，用AI协同编程',
    icon: 'ri-code-s-slash-line',
    color: 'from-orange-400 to-orange-600',
    buttonColor: 'from-orange-500 to-orange-600',
    objectives: ['算法应用体验', '决策树与神经网络', 'AI协同设计']
  },
  {
    id: 'grade6',
    grade: '六年级',
    title: '智能社会与系统设计',
    description: '理解控制系统，设计智能方案',
    icon: 'ri-rocket-line',
    color: 'from-indigo-400 to-indigo-600',
    buttonColor: 'from-indigo-500 to-indigo-600',
    objectives: ['智能社会应用', '控制系统原理', '设计智能系统']
  }
];

export default function PrimaryPage() {
  const [showModal, setShowModal] = useState(false);
  const [selectedModule, setSelectedModule] = useState<any>(null);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loginForm, setLoginForm] = useState({ username: '', password: '' });
  const [loginError, setLoginError] = useState('');

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setLoginError('');

    // 验证表单
    if (!loginForm.username || !loginForm.password) {
      setLoginError('请输入学号和密码');
      return;
    }

    // 模拟登录验证
    if (loginForm.username.length < 4) {
      setLoginError('学号格式不正确');
      return;
    }

    // 这里可以接入真实的登录接口
    // 目前显示提示信息
    alert('登录功能正在开发中，请联系学校管理员获取账号信息');
    setShowLoginModal(false);
    setLoginForm({ username: '', password: '' });
  };

  const handleContactSupport = () => {
    setShowLoginModal(false);
    // 触发 Readdy Agent
    const vapiButton = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (vapiButton) {
      vapiButton.click();
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-blue-50">
      <Navigation />

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 bg-pink-100 text-pink-700 px-6 py-3 rounded-full mb-8">
            <i className="ri-graduation-cap-line text-xl"></i>
            <span className="font-semibold">小学版块 · 1-6年级</span>
          </div>
          
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            AI 趣味体验与感知
          </h1>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-12 leading-relaxed">
            通过有趣的互动体验,让小朋友们感知AI的神奇魅力,培养对人工智能的兴趣和好奇心
          </p>

          <div className="flex flex-wrap justify-center gap-6 mb-16">
            <div className="bg-white rounded-2xl shadow-lg p-6 w-64">
              <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-lightbulb-line text-3xl text-pink-600"></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">感知</div>
              <div className="text-gray-600">体验AI工具</div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-6 w-64">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-hand-heart-line text-3xl text-blue-600"></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">体验</div>
              <div className="text-gray-600">动手实践操作</div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-6 w-64">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-star-line text-3xl text-purple-600"></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">创造</div>
              <div className="text-gray-600">发挥想象力</div>
            </div>
          </div>
        </div>
      </section>

      {/* Grade Modules */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">分年级学习路径</h2>
            <p className="text-xl text-gray-600">根据课程标准，循序渐进学习AI知识</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {gradeModules.map((module) => (
              <div
                key={module.id}
                onClick={() => window.REACT_APP_NAVIGATE(`/primary/${module.id}`)}
                className="bg-white rounded-3xl shadow-lg border-2 border-gray-100 hover:border-pink-300 transition-all hover:shadow-2xl cursor-pointer group"
              >
                <div className={`bg-gradient-to-r ${module.color} p-8 rounded-t-3xl`}>
                  <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <i className={`${module.icon} text-4xl text-white`}></i>
                  </div>
                  <div className="text-white text-sm font-semibold mb-2">{module.grade}</div>
                  <h3 className="text-2xl font-bold text-white mb-2">{module.title}</h3>
                  <p className="text-white/90 text-sm">{module.description}</p>
                </div>

                <div className="p-6">
                  <div className="space-y-2">
                    {module.objectives.map((objective, index) => (
                      <div key={index} className="flex items-center space-x-2 text-gray-700">
                        <i className="ri-checkbox-circle-fill text-pink-600"></i>
                        <span className="text-sm">{objective}</span>
                      </div>
                    ))}
                  </div>
                  <button className={`w-full mt-4 px-6 py-3 bg-gradient-to-r ${module.buttonColor} text-white rounded-lg font-semibold hover:shadow-lg transition-all whitespace-nowrap`}>
                    开始学习
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modules Grid */}
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">八大趣味模块</h2>
            <p className="text-xl text-gray-600">每个模块都是一次奇妙的AI探索之旅</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {modules.map((module) => (
              <ModuleCard key={module.id} {...module} />
            ))}
          </div>
        </div>
      </section>

      {/* Learning Path */}
      <section className="py-20 px-6 bg-gradient-to-r from-pink-50 to-purple-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">学习路径</h2>
            <p className="text-xl text-gray-600">循序渐进,螺旋上升</p>
          </div>

          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gradient-to-b from-pink-300 to-purple-300"></div>
            
            <div className="space-y-12">
              {[
                { grade: '1-2年级', title: '初识AI', content: '体验语音助手、智能绘图等适龄工具,感受AI的神奇' },
                { grade: '3年级', title: 'AI小伙伴', content: '与AI对话互动,养成良好、健康的人机交互习惯' },
                { grade: '4年级', title: 'AI小帮手', content: '使用AI识别物体、辅助学习,体验AI在生活中的应用' },
                { grade: '5-6年级', title: 'AI小创客', content: '了解算法原理,用AI进行创意创作,培养计算思维' }
              ].map((item, index) => (
                <div key={index} className={`flex items-center ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                  <div className={`w-1/2 ${index % 2 === 0 ? 'pr-12 text-right' : 'pl-12 text-left'}`}>
                    <div className="bg-white rounded-2xl shadow-xl p-8">
                      <div className="inline-block bg-pink-100 text-pink-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
                        {item.grade}
                      </div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-3">{item.title}</h3>
                      <p className="text-gray-600">{item.content}</p>
                    </div>
                  </div>
                  <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-purple-500 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg z-10">
                    {index + 1}
                  </div>
                  <div className="w-1/2"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-pink-500 to-purple-600">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            开启你的 AI 探索之旅
          </h2>
          <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
            登录学生账号，开始体验有趣的人工智能课程
          </p>
          <div className="flex justify-center space-x-4">
            <button 
              onClick={() => setShowLoginModal(true)}
              className="px-8 py-4 bg-white text-pink-600 rounded-lg font-bold hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              学生登录
            </button>
            <button 
              onClick={() => window.REACT_APP_NAVIGATE('/')}
              className="px-8 py-4 bg-pink-700 text-white rounded-lg font-bold hover:bg-pink-800 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              返回首页
            </button>
          </div>
        </div>
      </section>

      {/* Login Modal */}
      {showLoginModal && (
        <div 
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
          onClick={() => setShowLoginModal(false)}
        >
          <div 
            className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="bg-gradient-to-r from-pink-500 to-purple-600 p-6 text-white">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                    <i className="ri-user-smile-line text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold">小学生登录</h3>
                    <p className="text-white/80 text-sm">欢迎来到 AI 趣味学习世界</p>
                  </div>
                </div>
                <button 
                  onClick={() => setShowLoginModal(false)}
                  className="w-8 h-8 flex items-center justify-center hover:bg-white/20 rounded-full transition-all cursor-pointer"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
            </div>

            {/* Modal Body */}
            <form onSubmit={handleLogin} className="p-6 space-y-5">
              {/* Username Input */}
              <div>
                <label className="block text-gray-700 font-semibold mb-2 text-sm">
                  <i className="ri-user-line mr-2"></i>学号
                </label>
                <input
                  type="text"
                  value={loginForm.username}
                  onChange={(e) => setLoginForm({ ...loginForm, username: e.target.value })}
                  placeholder="请输入你的学号"
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-pink-500 focus:outline-none transition-all text-sm"
                />
              </div>

              {/* Password Input */}
              <div>
                <label className="block text-gray-700 font-semibold mb-2 text-sm">
                  <i className="ri-lock-line mr-2"></i>密码
                </label>
                <input
                  type="password"
                  value={loginForm.password}
                  onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
                  placeholder="请输入密码"
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-pink-500 focus:outline-none transition-all text-sm"
                />
              </div>

              {/* Error Message */}
              {loginError && (
                <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg text-sm flex items-center">
                  <i className="ri-error-warning-line mr-2"></i>
                  {loginError}
                </div>
              )}

              {/* Info Box */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-information-line text-blue-600 text-xl mt-0.5"></i>
                  <div className="text-sm text-blue-800">
                    <p className="font-semibold mb-1">温馨提示：</p>
                    <ul className="space-y-1 text-blue-700">
                      <li>• 学号由学校统一分配</li>
                      <li>• 初始密码为身份证后6位</li>
                      <li>• 如忘记密码，请联系班主任</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex space-x-3 pt-2">
                <button
                  type="submit"
                  className="flex-1 px-6 py-3 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-lg font-bold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-login-box-line mr-2"></i>
                  立即登录
                </button>
                <button
                  type="button"
                  onClick={handleContactSupport}
                  className="flex-1 px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-semibold hover:bg-gray-200 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-customer-service-2-line mr-2"></i>
                  联系老师
                </button>
              </div>

              {/* Additional Links */}
              <div className="text-center pt-2">
                <button
                  type="button"
                  onClick={() => {
                    setShowLoginModal(false);
                    window.REACT_APP_NAVIGATE('/');
                  }}
                  className="text-sm text-gray-500 hover:text-pink-600 transition-all cursor-pointer"
                >
                  返回首页
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
